import './GenderFilter.sass';

import React, { FC, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Header, ScrollView, SelectList } from '$uikit';
import { useTranslator } from '$hooks';
import { genderFilterSelector } from '$store/main';
import { profileActions } from '$store/profile';
import { AuthRequired } from '$core';
import { authSelector } from '$store/auth';
import { GenderFilterEnum } from '$store/models';

export const GenderFilter: FC = () => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const genderFilter = useSelector(genderFilterSelector);
  const { isLogged } = useSelector(authSelector);

  const options = useMemo(
    () => [
      {
        label: t('gender_filter_option_women'),
        value: GenderFilterEnum.WOMEN,
      },
      {
        label: t('gender_filter_option_men'),
        value: GenderFilterEnum.MEN,
      },
      {
        label: t('gender_filter_option_both'),
        value: GenderFilterEnum.BOTH,
      },
    ],
    [t],
  );

  const value =
    genderFilter === GenderFilterEnum.NONE ? GenderFilterEnum.WOMEN : genderFilter;

  const handleChange = useCallback(
    ([value]: GenderFilterEnum[]) => {
      dispatch(
        profileActions.changeGenderPriority({
          genderFilter: value,
          needClearFeed: true,
        }),
      );
    },
    [dispatch],
  );

  if (!isLogged) {
    return <AuthRequired />;
  }

  return (
    <>
      <Header showBackButton>{t('gender_filter_title')}</Header>
      <ScrollView>
        <div className="GenderFilter">
          <SelectList
            description={<b>{t('gender_filter_description')}</b>}
            value={[value]}
            options={options}
            onChange={handleChange}
          />
        </div>
      </ScrollView>
    </>
  );
};
